import React from 'react';

import { Select, TextField } from '@material-ui/core';
import { typography, TypographyProps } from '@material-ui/system';

import filterProps from 'utils/filterProps';

import styled from 'styled-components';

export type StyleProps = {
  //   width?: string;
  typography?: string;
  weight?: string;
  height?: string;
  setColor?: string;
  fontSize?: string;
  error?: string;
};

interface StyledLabelSelectProps {
  color?: string;
  fontSize?: string;
  text?: string;
}

export const StyledLabelSelect: any = styled(filterProps<StyledLabelSelectProps>(Select, []))`
  .MuiSelect-icon {
    color: ${props => props.color};
  }

  .MuiInputBase-input {
    color: ${props => props.color};
    text-transform: ${props => props.text};
    font-weight: bold;
    font-size: 0.875rem;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const StyledSelect = styled(
  filterProps<StyleProps>(Select, ['setColor', 'typography', 'weight', 'height', 'fontSize']),
)<StyleProps>`
  background: #fff;
  box-shadow: 0px 3px 2px #00000005;
  border-radius: 0.625rem;
  min-height: 47px;
  border: 1px solid #d5d7db;

  & .MuiSelect-root {
    padding: 0.875rem !important;
    color: ${props => props.setColor || '#454545'};
    font-size: ${props => props.fontSize || '1rem'};
    border-radius: 0.625rem;
    border: ${props => props.error && '1px solid #D74545'};

    @media (max-width: 470px) {
      padding: 18.5px 17px !important;
    }
  }

  & .MuiSelect-icon {
    font-size: 2rem;
    color: #898989;
    top: auto;
  }

  & .MuiSelect-iconFilled {
    right: 12px;
  }
`;

export const StyledTextInput = styled(TextField).withConfig({
  shouldForwardProp: prop => !['maxWidth', 'setColor', 'weight', 'fontSize'].includes(prop),
})<{ maxWidth?: 'string' | undefined; disabled?: boolean } & StyleProps>`
  box-shadow: 0px 3px 2px #00000005;
  border: 1px solid #d5d7db;
  border-radius: 10px;

  & .MuiFilledInput-root {
    padding: 0;
    border-radius: 10px;
    ${p => (p.disabled ? 'background: #D9D9D9;' : 'background: #fff;')}
  }

  & .MuiFilledInput-input {
    ${p => (p.disabled ? 'background: #D9D9D9;' : 'background: #fff;')}
    border-radius: 10px;

    padding: 0.875rem !important;
    color: ${props => props.setColor || '#454545'};
    font-size: ${props => props.fontSize || '1rem'};

    &:hover {
      ${p => (p.disabled ? '' : 'background: rgba(0, 0, 0, 0.09);')}
    }

    &:focus {
      ${p => (p.disabled ? '' : 'background: rgba(0, 0, 0, 0.09);')}
    }
  }

  & .MuiIconButton-label {
    font-size: 2rem;
    color: #a0a0a0;
  }

  & .MuiAutocomplete-endAdornment {
    top: auto;
    right: 12px;
  }
`;

const InputTags = styled.span`
  margin-left: 4px;
  width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #454545;
  font-size: 1rem;
  padding: 0 0.5rem;

  @media screen and (${p => p.theme.breakpoints.down('lg')}) {
    margin-left: 1px;
    width: 55%;
  }

  @media (max-width: 470px) {
    font-size: 0.875rem;
  }

  ${typography}
`;

export function makeRenderTags<T>(getLabel: (option: T) => void, typographyProps?: TypographyProps) {
  return (values: T[]) => (
    <InputTags {...typographyProps}>{values.map(option => getLabel(option)).join(', ')}</InputTags>
  );
}
